import c from 'classnames';
import styles from './ToolbarPlugin.module.css';

type ToolbarButtonProps = {
  onClick: () => void;
  isActive?: boolean;
  ariaLabel: string;
  children: React.ReactNode;
};

export function ToolbarButton({ onClick, isActive, ariaLabel, children }: ToolbarButtonProps) {
  return (
    <button
      onClick={onClick}
      className={c({ [styles.active]: isActive })}
      aria-label={ariaLabel}
      type="button"
    >
      {children}
    </button>
  );
}
